module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/social/youtube-5320929d1806f7a9b73b7a2f1db0aa9d.svg";